const tests = {
  TEST_PLACEBO_2: '0000_placebo_2',
  // TEST_PLACEBO_3: '0000_placebo_3',
  // TEST_PLACEBO_4: '0000_placebo_4',
  TEST_PLACEBO_5: '0000_placebo_5',
  // TEST_DYNAMIC_AB_TEST: '0000_dynamic_ab_test',
  TEST_DYNAMIC_PLACEBO_2: '0000_dynamic_placebo_2',
  TEST_DYNAMIC_PLACEBO_3: '0000_dynamic_placebo_3',
  TEST_DYNAMIC_PLACEBO_4: '0000_dynamic_placebo_4',
  TEST_DYNAMIC_PLACEBO_5: '0000_dynamic_placebo_5',

  // TEST_FRIEND_REFERRAL: '0001_friend_referral',
  // TEST_INGAME_PROFILE: '0002_ingame_profile',
  // TEST_MATCH3_MINIGAME: '0003_match3_minigame',
  // TEST_AFFINITY_FRIENDS: '0004_affinity_friends',
  // TEST_TUTORIAL_BUTTONS: '0005_tutorial_buttons',
  // TEST_ENERGY_GIFT: '0006_energy_gift',
  // TEST_ENERGY_REFILL_TIME: '0007_energy_refill_time',
  // TEST_EVOLUTION_AND_DEATH: '0008_evolution_and_death',
  // TEST_VISIT_FRIENDS: '0009_visit_friends',
  // TEST_ENERGY_GIFT_POPUP: '0010_energy_gift_popup',
  // TEST_TUTORIAL_REWARD: '0011_tutorial_reward',
  // TEST_UNLOCK_FRIEND_INVITE: '0012_unlock_friend_invite',
  // TEST_INVITE_POPUP_LOW_BALANCE: '0013_invite_popup_low_balance',
  // TEST_INVITE_REWARD: '0014_invite_reward',
  // TEST_VISIT_FRIENDS_FIX: '0016_visit_friends_fix',
  // TEST_DEATH: '0017_death',
  // TEST_IMPROVE_IN_GAME_PROFILE_CVR: '0018_improve_in_game_profile_cvr',
  // TEST_CROSSPLAY_PROMOTION: '0020_crossplay_promotion',

  // TEST_GEM_PINCH_INVITE: '0021_gem_pinch_invite', // Resolved to enabled
  // TEST_DAILY_MESSAGES: '0022_daily_messages', // Resolved to control
  // TEST_MESSAGE_TESTING: '0023_message_testing', // Resolved to control
  // TEST_INTENT_SHARING: '0024_intent_sharing', // Resolved to control
  // TEST_VIRAL_FLOW_ON_LAUNCH: '0025_viral_flow_on_launch', // Resolved to control
  // TEST_SLEEP_TIME: '0026_sleep_time', // Resolved to user-later
  // TEST_CONVERSATIONAL_CHATBOT: '0027_conversational_chatbot',
  TEST_CONVERSATIONAL_CHATBOT: '0028_conversational_chatbot',
  TEST_QUIZ_EGG_CHAT: '0029_quiz_egg_chat',
} as const;

/**
 * GCinstant receiver ab test
 */
const receiverTests: ABTestID[] = [];

/**
 * GCinstant ab tests config
 */
const config = {
  // DO NOT USE GCINSTANT AB TESTS IN THE FUTURE
  [tests.TEST_PLACEBO_2]: createGCInstantTest('a', 'b'),
};

/**
 * Replicant dynamic ab tests config
 * Could be controlled from CStool
 */
const dynamicAB = {
  [tests.TEST_DYNAMIC_PLACEBO_2]: createTest('a', 'b'),
  [tests.TEST_DYNAMIC_PLACEBO_3]: createTest('a', 'b', 'c'),
  [tests.TEST_DYNAMIC_PLACEBO_4]: createTest('a', 'b', 'c', 'd'),
  [tests.TEST_DYNAMIC_PLACEBO_5]: createTest('a', 'b', 'c', 'd', 'e'),
  [tests.TEST_CONVERSATIONAL_CHATBOT]: createTest(
    'control',
    'generic',
    'actioned',
  ),
  [tests.TEST_QUIZ_EGG_CHAT]: createTest('control', 'enabled'),
};

const contextConfig = {
  // DO NOT USE GCINSTANT AB TESTS IN THE FUTURE
  [tests.TEST_PLACEBO_5]: createGCInstantTest('a', 'b', 'c', 'd', 'e'),
};

const assignableContextTests: ContextABTestID[] = [tests.TEST_PLACEBO_5];

export default {
  tests,
  contextConfig,
  assignableContextTests,
  config,
  receiverTests,
  dynamicAB,
};

export type ABTests = typeof config;
export type ABTestID = keyof ABTests;
export type ContextABTests = typeof contextConfig;
export type ContextABTestID = keyof ContextABTests;
export type ReceiverABTestID = typeof receiverTests[number];
export type ManuallyAssignedABTestID = {
  [K in ABTestID]: ABTests[K] extends { assignManually: boolean } ? K : never;
}[ABTestID];

export type ABTestBucket<
  T extends ABTestID
> = ABTests[T]['buckets'][number]['id'];

export type ContextABTestBucket<
  T extends ContextABTestID
> = ContextABTests[T]['buckets'][number]['id'];

export type RunningABTests = {
  [K in ABTestID]: ABTestBucket<K> | null | undefined;
};

//
// Helpers

function createGCInstantTest<
  A extends string,
  B extends string,
  T extends string[]
>(a: A, b: B, ...buckets: T) {
  return { active: true, default: a, ...createTest(a, b, ...buckets) };
}
function createTest<A extends string, B extends string, T extends string[]>(
  a: A,
  b: B,
  ...buckets: T
) {
  return {
    buckets: [a, b, ...buckets].map((bucket: A | B | T[number]) => ({
      id: bucket,
    })),
  };
}

// Dynamic replicant ab tests helpers
export type DynamicABTests = typeof dynamicAB;
export type DynamicABTestID = keyof DynamicABTests;
export type DynamicABTestBucket<
  T extends DynamicABTestID
> = DynamicABTests[T]['buckets'][number]['id'] & string;

export type DynamicABTestBucketID<
  TDynamicABTestID extends DynamicABTestID = DynamicABTestID
> = DynamicABTestBucket<TDynamicABTestID>;

// Helper to get a dynamic ab test bucket id from api
export function getDynamicBucketID<T extends DynamicABTestID>(
  api,
  test: T,
): DynamicABTestBucket<T> {
  const bucket = api.abTests.getBucketID(test);
  return bucket as DynamicABTestBucket<T>;
}

// Helper to get a dynamic ab test bucket id from state
export function getStateBucketID<T extends DynamicABTestID>(
  state,
  test: T,
): DynamicABTestBucket<T> {
  const bucket = state?.ruleset?.abTests?.[test]?.bucketId;
  return bucket as DynamicABTestBucket<T>;
}
